import styled from 'styled-components';

const Styled = styled.div`

  .nav-link {
    cursor: pointer;
    background-color: white;
    border: 1px solid #579dd94d;
    margin-right: 1px;
    margin-left: 1px;
  }

  .active.nav-link {
    background-color: #579dd94d;
  }

`;

export default Styled;

// eb0029   red
// 013a81 blue
